import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import ProfileImage from '../other/ProfileImage';
/**
 * This component is used to render some item in a standard card form.
 * This includes a profile pic, a title, a subtitle and a list of fields and values.
 * @export
 *
 * @example
 * ```
 *  <ItemCard
 *      item={{
 *          request: "AC Extension request #36",
 *          user: "Johnson & Johnson",
 *          section: "Parking 1",
 *          status: "approved",
 *          date: "23/0702020"
 *      }}
 *      titleField="request"
 *      subTitleField="date"
 *      className="data-table-item"
 *  />
 * ```
 *
 * @example
 * ```
 *  <ItemCard
 *      item={{
 *          id: "1",
 *          image: "https://avatars.dicebear.com/api/male/john.svg?background=%230000ff"
 *          name: "John Doe",
 *      }}
 *      imageField="image"
 *      titleField="name"
 *      className="data-table-item"
 *  />
 * ```
 *
 * * @example
 * ```
 *  <ItemCard
 *      image="https://avatars.dicebear.com/api/male/john.svg?background=%230000ff"
 *      title="John Doe"
 *      className="data-table-item"
 *  />
 * ```
 *
 * @category Data Display/Cards
 */
const ItemCard = (props) => {
    let { item, imageField, titleField, subTitleField, nameField, className, image, name, title, subTitle, size, shape } = props;
    let ImageComponent = null;
    if (!item && !image && !name) {
        ImageComponent = _jsxs("div", { className: "uxpcore_itemcard__image", children: [" ", _jsx(ProfileImage, { className: "placeholder", size: size, shape: shape })] });
    }
    if (item && imageField && item[imageField]) {
        ImageComponent = _jsxs("div", { className: "uxpcore_itemcard__image", children: [" ", _jsx(ProfileImage, { image: item[imageField], size: size, shape: shape })] });
    }
    else if (image) {
        ImageComponent = _jsxs("div", { className: "uxpcore_itemcard__image", children: [" ", _jsx(ProfileImage, { image: image, size: size, shape: shape })] });
    }
    else if (item && nameField && item[nameField]) {
        ImageComponent = _jsxs("div", { className: "uxpcore_itemcard__image", children: [" ", _jsx(ProfileImage, { name: item[nameField], size: size, shape: shape })] });
    }
    else if (name) {
        ImageComponent = _jsxs("div", { className: "uxpcore_itemcard__image", children: [" ", _jsx(ProfileImage, { name: name, size: size, shape: shape })] });
    }
    function getValue(item, field, value) {
        if (item && item.hasOwnProperty(field)) {
            return item[field];
        }
        else if (value) {
            return value;
        }
        return "";
    }
    return (_jsxs("div", { className: classNames("uxpcore_itemcard", className, { "uxpcore_itemcard--placeholder": (!item && !title && !subTitle) }), children: [ImageComponent, _jsxs("div", { className: "uxpcore_itemcard__content", children: [((item && titleField) || title) && _jsx("div", { className: "uxpcore_itemcard__title", children: getValue(item, titleField, title) }), ((item && subTitleField) || subTitle) && _jsx("div", { className: "uxpcore_itemcard__subtitle", children: getValue(item, subTitleField, subTitle) })] })] }));
};
export default ItemCard;
